<template>
  <div class="content-wrapper">
    <div class="mt-3 mb-3"></div>
    <div class="content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-5" style="padding:0;padding-bottom: 35px;">
            <!-- Profile Image -->
            <div class="card card-info">
              <div class="card-header">
                <h3 class="card-title">Actualizar Datos</h3>
                <div class="col-sm-6" style="width: 125px; padding-right: 0px; float: right">
                  <router-link to="/perfil">
                  <button type="button" class="btn btn-block bg-gradient-info btn-sm">
                    <i class="far fa-arrow-alt-circle-left" style="padding: 5px"></i>
                    Retroceder
                  </button>
                  </router-link>
                </div>
              </div>
              <div class="card-body">
              <form 
                v-if="validacion" 
                v-on:submit.prevent="ValidacionDNI" 
                method="get" 
                autocomplete="off" 
                aria-autocomplete="off" 
                style="padding-bottom: 15px;border-bottom: 2px solid;">
                <p 
                class="reserva mensajedni" 
                style="text-align: justify;" 
                v-if="this.content.ValidacionDNI != 1">
                <b>Si tu n° DNI es INCORRECTO contacta a tu representante zonal para realizar la actualización.</b>
                </p>
                <div class="input-group">
                  <label class="col-form-label" style="width: 100%;text-align: left;">
                  DNI
                  </label>
                  <input
                    type="number"
                    class="form-control"
                    @keypress="MaxNumber($event)"
                    pattern="^[0-9]+"
                    oninput="validity.valid||(value='');"
                    v-model="devolverPerfil.sDni"
                    placeholder="XXXXXXXXX" 
                    onwheel="this.blur()"
                    step="1-9"
                    autocomplete="off"
                    disabled
                    required 
                  />
                </div>
                <p 
                class="reserva mensajedni" 
                v-if="this.content.ValidacionDNI != 1">
                <b>Si tus apellidos y nombres son incorrectos dar click en el boton MODIFICAR.</b>
                </p>
                <div class="input-group">
                  <label
                    class="col-form-label"
                    for="inputWarning"
                    style="width: 100%;text-align:left">
                  Nombres</label>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Nombres"
                    v-model="devolverPerfil.sNombre_2"
                    disabled
                    required
                  />
                  <div class="input-group-append">
                  </div>
                </div>
                <div class="input-group">
                  <label
                    class="col-form-label"
                    for="inputWarning"
                    style="width: 100%;text-align:left"
                  >
                  Apellidos</label>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Apellidos"
                    v-model="devolverPerfil.sNombre_1"
                    disabled
                    required
                  />
                  <div class="input-group-append">
                  </div>
                </div>
                <button type="submit" 
                   class="btn btn-success color-sokso" 
                   style="width:48%;margin-top:15px"  
                   v-if="this.content.ValidacionDNI != 1">
                   Conforme</button>
                   <button 
                   type="button" 
                   v-if="this.content.ValidacionDNI != 1"
                   class="btn btn-info" 
                   style="width:48%;margin-top:15px;float:right"  
                   @click="NoConforme()">
                   Modificar</button>
              </form>
              <div v-if="mensajebotonmodal" style="
                text-align: center;
                text-align: center;
                padding: 5px;
                background: rgb(253, 253, 218);
                margin: 0px auto;
                border-radius: 5px;
                margin-top: 10px;">
                <div> 
                <i class="fas fa-exclamation-triangle" 
                style="color: #ffc107;
                font-size: 40px;"></i></div> 
                <p class="reserva" style="    margin-bottom: 0px;
                color: rgb(90, 45, 130);
                font-size: 15px;
                width: 100%"><b>Si usted modifica su DNI, su usuario será su DNI Actualizado.</b></p>
                </div>
                <form 
                v-if="modificar" 
                v-on:submit.prevent="ModiDNI"
                method="get" 
                autocomplete="off" 
                aria-autocomplete="off"
                style="padding-bottom: 15px;border-bottom: 2px solid;">
                  <div class="input-group" v-if="inputdisabled">
                  <label
                  class="col-form-label"
                  style="width: 100%;text-align:left"
                  >
                  DNI</label>
                  <input
                  type="number"
                  class="form-control"
                  @keypress="MaxNumber($event)"
                  pattern="^[0-9]+"
                  oninput="validity.valid||(value='');"
                  v-model="DNI"
                  placeholder="XXXXXXXXX" 
                  onwheel="this.blur()"
                  step="1-9"
                  autocomplete="off"
                  @click="Limpiar()"
                  disabled
                  required 
                  />
                  <div 
                  class="input-group-append" 
                  v-if="this.content.ValidacionDNI != 1">
                  <button type="button" class="btn btn-success" @click="Reniec()"
                  style="background-color: rgb(90, 45, 130) !important;border-color:none">
                  <i class="fas fa-search"></i>
                  </button>
                  </div>
                  </div>
                  <div class="input-group" v-else>
                  <label
                  class="col-form-label"
                  style="width: 100%;text-align:left"
                  >
                  DNI</label>
                  <input
                    type="number"
                    class="form-control"
                    @keypress="MaxNumber($event)"
                    pattern="^[0-9]+"
                    oninput="validity.valid||(value='');"
                    v-model="DNI"
                    placeholder="XXXXXXXXX" 
                    onwheel="this.blur()"
                    step="1-9"
                    autocomplete="off"
                    @click="Limpiar()"
                    required 
                  />
                  <div class="input-group-append" v-if="this.content.ValidacionDNI != 1">
                    <button type="button" 
                    class="btn btn-success" 
                    @click="Reniec()"
                    style="background-color: rgb(90, 45, 130) !important;border-color:none">
                    <i class="fas fa-search"></i>
                    </button>
                  </div>
                </div>
                <div class="input-group">
                  <label
                    class="col-form-label"
                    for="inputWarning"
                    style="width: 100%;text-align:left">
                    Nombres</label>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Nombres"
                    v-model="Nombres"
                    required
                    disabled
                  />
                  <div class="input-group-append">
                    <span class="input-group-text">
                    <i class="fas fa-asterisk"></i>
                    </span>
                  </div>
                </div>
                <div class="input-group">
                  <label
                    class="col-form-label"
                    for="inputWarning"
                    style="width: 100%;text-align:left">
                    Apellidos</label>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Apellidos"
                    v-model="Apellidos"
                    disabled
                    required
                  />
                  <div class="input-group-append">
                    <span class="input-group-text">
                    <i class="fas fa-asterisk"></i>
                   </span>
                  </div>
                </div>
                <button type="submit" 
                  v-if="this.content.ValidacionDNI != 1"
                   class="btn btn-success color-sokso" 
                   style="width:48%;;margin-top:15px"  >
                   Conforme</button>
                   <button type="button" 
                   v-if="this.content.ValidacionDNI != 1"
                   class="btn btn-info" 
                   style="width:48%;margin-top:15px;float:right"  
                  @click="Retorno()">
                   Retornar</button>
              </form>
              <div class="input-group">
                <label
                class="col-form-label"
                style="width: 100%;text-align:left">
                Celular</label>
                <input
                type="number"
                class="form-control"
                v-model="devolverPerfil.sCelular"
                @keypress="MaxNumberCell($event)"
                pattern="^[9][0-9]+"
                oninput="validity.valid||(value='');"
                placeholder="XXXXXXXXX" 
                onwheel="this.blur()"
                min="9"
                max="999999999"
                autocomplete="off"
                id="celu"
                required
                @click="LimpiarCel()">
                <div class="input-group-append">
                  <span class="input-group-text">
                  <i class="fas fa-mobile-alt"></i>
                  </span>
                  </div>
                </div>
                <div 
                v-if="smsPendAproved" 
                style="padding-bottom: 15px;border-bottom: 2px solid;">
                <div 
                  class="col-md-12" 
                  style="padding:0;margin-top: 10px;" 
                  v-if="this.content.ValidacionCelular != 1">
                  <button 
                  type="button" 
                  class="btn btn-info" 
                  style="width:100%;" 
                  @click="celularVerify">
                  Verificar Celular</button>
                </div>
                <div v-if="ModalValidaCel" class="col-md-12 text-center" style="margin-top: 15px;background: rgb(90, 45, 130);color: #fff;padding: 8px;">
                  <p style="margin:0">Si tienes problemas en verificar tu CELULAR llena el siguiente
                    <a target="_blank" @click="ModalCel()"
                    style="color: rgb(255, 255, 255);text-decoration: underline;background: rgb(227, 60, 189) !important;font-weight: 700;" >FORMULARIO</a> para ayudarte.</p>
                </div>
                <div 
                  class="col-md-12 text-center" 
                  style="margin-top: 10px;" 
                  v-if="sendSms">
                  <span style="font-weight:700">Ingrese su código de 5 dígitos que enviamos por SMS a su celular</span>
                </div>
                <div class="col-md-12 text-center" v-if="sendSms">
                  <input 
                  type="number"  
                  min="1" 
                  max="99999"  
                  style="margin-top: 10px;margin-bottom: 10px;"
                  @keypress="maxCode($event)" 
                  class="form-control" 
                  v-model="codeInserted" 
                  placeholder="Ingrese Codigo SMS" 
                  autocomplete="off">
                  <span class="text-validacion">REVISA TU BANDEJA DE MENSAJES</span><br>
                  <button 
                  type="button" 
                  class="btn btn-info color-sokso" 
                  style="margin-top:17px; margin-bottom:17px;" 
                  @click="smsValidate">
                  Verificar</button>
                </div>
                <div class="col-md-12 text-center" v-if="sendSms">
                  <span v-if="smsTime"> Tiempo Restante <b>{{timeLeft}}</b></span>
                  <a href="#" v-if="!smsTime">  </a>
                </div>
                </div>
                <div class="col-md-12 text-center" v-if="!smsPendAproved" style="margin-top: 10px;padding:0">
                  <span style="color: #5a2d82;font-weight: 700;">Celular Validado <i class="fas fa-check"></i></span>
                </div>
                <div class="col-md-12 text-center" v-if="ConformeCel" style="padding:0">
                  <div class="col-md-12" style="padding:0;margin-top: 10px;">
                    <button type="button" class="btn btn-info" style="width:100%;" @click="ValidacionCelular()" >Conforme</button>
                  </div>
                </div>
                <form  v-on:submit.prevent="correoVerify" method="get" autocomplete="off" aria-autocomplete="off">
                  <div class="input-group">
                    <label
                      class="col-form-label"
                      for="inputWarning"
                      style="width: 100%;text-align:left">
                    Email</label>
                    <input type="email" 
                    class="form-control" 
                    placeholder="correo@sokso.com" 
                    v-model="devolverPerfil.sCorreoPromotora" 
                    id="email"
                    @click="LimpiarCorreo()"
                    requerid>
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="far fa-envelope"></i>
                      </span>
                    </div>
                  </div>
                  <div v-if="smsPendAprovedcorreo">
                    <div class="col-md-12" style="padding:0;margin-top: 10px;" v-if="this.content.ValidacionCorreo != 1">
                      <button type="submit" class="btn btn-info" style="width:100%;" >Verificar Correo</button>
                    </div>
                    <div v-if="ModalValidaCorreo" class="col-md-12 text-center" style="margin-top: 15px;background: rgb(90, 45, 130);color: #fff;padding: 8px;">
                    <p style="margin:0">Si tienes problemas en verificar tu CORREO llena el siguiente
                    <a target="_blank" @click="ModalCorreo()"
                    style="color: rgb(255, 255, 255);text-decoration: underline;background: rgb(227, 60, 189) !important;font-weight: 700;" >FORMULARIO</a> para ayudarte.</p>
                    </div>
                    <div class="col-md-12 text-center" style="margin-top: 10px;" v-if="sendSmscorreo">
                      <span style="font-weight:700">Ingrese su código de 5 dígitos que enviamos a su correo</span>
                    </div>
                    <div class="col-md-12 text-center" v-if="sendSmscorreo">
                      <input type="number"  
                      style="    margin-top: 10px;margin-bottom: 10px;" min="1" max="99999"  @keypress="maxCode($event)" class="form-control" v-model="codeInsertedcorreo" placeholder="Ingrese Codigo de su Correo" autocomplete="off">
                      <span class="text-validacion">REVISA TU BANDEJA DE ENTRADA, NO DESEADOS O SPAM</span><br>
                      <button type="button" class="btn btn-info color-sokso" style="margin-top:17px; margin-bottom:17px;" @click="smsValidateCorreo">Verificar</button>
                    </div>
                    <div class="col-md-12 text-center" v-if="sendSmscorreo">
                      <span v-if="smsTimecorreo"> Tiempo Restante <b>{{timeLeftcorreo}}</b></span>
                      <a href="#" v-if="!smsTimecorreo">  </a>
                    </div>
                  </div>
                  <div class="col-md-12 text-center" v-if="!smsPendAprovedcorreo" style="margin-top: 10px;padding:0">
                    <span style="color: #5a2d82;font-weight: 700;">Correo Validado <i class="fas fa-check"></i></span>
                  </div>
                  <div class="col-md-12 text-center" v-if="ConformeCorreo" style="padding:0">
                    <div class="col-md-12" style="padding:0;margin-top: 10px;">
                      <button type="button" class="btn btn-info" style="width:100%;"  @click="ValidacionCorreo()">Conforme</button>
                    </div>
                  </div>
                </form>
                <!-- -->
                <div class="overlay-wrapper" v-if="modalload">
                <div class="overlay" style="flex-direction: column">
                  <i class="fas fa-3x fa-sync-alt fa-spin"></i>
                  <div class="text-bold pt-2">Cargando...</div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<ModalPeque v-show="ModalPeque.isValidaCel" :peque="ModalPeque">
    <div class="col-md-12" >
      <p style='font-size: 14px;
      text-align: justify;
      margin: 0;
      padding: 15px 0px;'>Estimad@ Estrella, SOKSO te ayudará en la verificación, para ello requerimos los siguientes datos:</p>
      <div class="input-group">
      <label
      class="col-form-label"
      style="width: 100%;text-align:left">
      CELULAR</label>
      <input type="number"
      class="form-control"
      v-model="devolverPerfil.sCelular"
      @keypress="MaxNumberCell($event)"
      pattern="^[9][0-9]+"
      oninput="validity.valid||(value='');"
      placeholder="XXXXXXXXX" 
      onwheel="this.blur()"
      min="9"
      max="999999999"
      autocomplete="off"
      id="celu">        
      </div>
      <div class="input-group">
      <label
      class="col-form-label"
      style="width: 100%;text-align:left">
      MOTIVO DEL PROBLEMA</label>
      <textarea  
      class="form-control" 
      v-model="MotivoCel" 
      rows="4"
      >      
      </textarea>
      </div>
      
      <p style='font-size: 14px;
      text-align: justify;
      margin: 0;
      padding: 15px 0px 25px 0px;'>Para proceder con la verificación, es necesario que adjuntes la imagen del perfil de tu whatsapp donde se visualiza el número de celular</p>
      <div class="form-group col-lg-6 col-md-12" style="float:left;padding:0">
                    <label for="exampleInputFile">Adjuntar Perfil de WhatsApp</label>
                    <div class="input-group">
                      <div class="custom-file">
                        <input type="file" class="custom-file-input" id="portada" accept=".png, .jpg, .jpeg, .gif" @change="CargaIMG()">
                        <label class="custom-file-label" for="portada" v-if="!CargadoPortada" style="text-align: left;">Sube una imagen</label>
                        <label class="custom-file-label" for="portada" v-if="CargadoPortada" style="text-align: left;">{{NombrePortada}}</label>
                      </div>
                    </div>
      <div class="col-lg-12 col-md-12" id="preview" v-if="CargadoPortada"></div>
      </div>
      <div class="form-group col-lg-6 col-md-12" v-if="!CargadoPortada" style="float:left">
        <label for="exampleInputFile">Por Ejemplo :</label>
        <img :src="PERFIL_WHATSAPP" 
        style="width: 100%;">
      </div>
       <div
              class="col-md-12"
              style="
                width: 100%;
                padding: 0px;
                border-top: 0px;
                margin: 0 auto;
                padding-bottom: 30px;
                float: left;
              "
            >
              <button
                type="button"
                class="btn btn-success"
                id="elimin"
                @click="GuardarCel()"
                
              >
                Guardar
              </button>
              <button
                type="button"
                class="btn btn-danger"
                style="margin-left: 5px; "
                @click="this.ModalPeque.isValidaCel=false"
              >
                Cancelar
              </button>
            </div>
    </div>
   
</ModalPeque>
<ModalPeque v-show="ModalPeque.isValidaCorreo" :peque="ModalPeque">
    <div class="col-md-12" >
      <p style='font-size: 14px;
      text-align: justify;
      margin: 0;
      padding: 15px 0px;'>Estimada Estrella, SOKSO te ayudará en la verificación, para ello requerimos los siguientes datos:</p>
      <div class="input-group">
      <label
      class="col-form-label"
      style="width: 100%;text-align:left">
      CORREO</label>
      <input type="email" 
                    class="form-control" 
                    placeholder="correo@sokso.com" 
                    v-model="devolverPerfil.sCorreoPromotora" 
                    id="email">     
      </div>
      <div class="input-group">
      <label
      class="col-form-label"
      style="width: 100%;text-align:left">
      MOTIVO DEL PROBLEMA</label>
      <textarea  
      class="form-control" 
      v-model="MotivoCorreo" 
      rows="4"
      >      
      </textarea>
      </div>
      
      <p style='font-size: 14px;
      text-align: justify;
      margin: 0;
      padding: 15px 0px 25px 0px;'>Para proceder con la verificación, es necesario que adjuntes la imagen del perfil de tu correo.</p>
      <div class="form-group col-lg-6 col-md-12" style="float:left;padding:0">
                    <label for="exampleInputFile">Adjuntar Perfil Correo</label>
                    <div class="input-group">
                      <div class="custom-file">
                        <input type="file" class="custom-file-input" id="fotocorreo" accept=".png, .jpg, .jpeg, .gif" @change="CargaIMGCorreo()">
                        <label class="custom-file-label" for="portada" v-if="!CargadoPortada" style="text-align: left;">Sube una imagen</label>
                        <label class="custom-file-label" for="portada" v-if="CargadoPortada" style="text-align: left;">{{NombrePortada}}</label>
                      </div>
                    </div>
      <div class="col-lg-12 col-md-12" id="previewcorreo" v-if="CargadoPortada"></div>
      </div>
      <div class="form-group col-lg-6 col-md-12" v-if="!CargadoPortada" style="float:left">
        <label for="exampleInputFile">Por Ejemplo :</label>
        <img :src="PERFIL_CORREO" 
        style="width: 100%;">
      </div>
      
    </div>
    <div
              class="col-md-12"
              style="
                width: 100%;
                padding: 0px;
                border-top: 0px;
                margin: 0 auto;
                padding-bottom: 30px;
                float: left;
              "
            >
              <button
                type="button"
                class="btn btn-success"
                id="elimin"
                @click="GuardarCorreo()"
                
              >
                Guardar
              </button>
              <button
                type="button"
                class="btn btn-danger"
                style="margin-left: 5px; "
                @click="this.ModalPeque.isValidaCorreo=false"
              >
                Cancelar
              </button>
            </div>
</ModalPeque>
<ModalPeque v-show="ModalPeque.isMensajeCanje" :peque="ModalPeque">
    <div class="col-md-12" >
      <p class="titulo-sms-canje">¡Muy Bien!</p>
      <p style="font-size:22px">cumpliste las condiciones. <br> Ahora canjea tu premio</p>
    <div class="col-md-12" >
      <router-link to="/premio-canje">
      <button class="btn btn-success color-sokso" style="font-size:22px;width:120px">AQUÍ</button>
      </router-link>
    </div>
            </div>
</ModalPeque>
<ModalPeque v-show="ModalPeque.isMensajeFalta" :peque="ModalPeque">
    <div class="col-md-12" >
      <p class="titulo-sms-canje">¡Muy Bien!</p>
      <p style="font-size:22px">Ahora solo te falta realizar una compra facturada dentro de la campaña.</p>
    <div class="col-md-12" >
      <router-link to="/solicitud-pedidos">
      <button class="btn btn-success color-sokso" style="font-size:22px;width:120px">AQUÍ</button>
      </router-link>
    </div>
            </div>
</ModalPeque>
<ModalPeque v-show="ModalPeque.isMensajeValidacionCel" :peque="ModalPeque">
    <div class="col-md-12" >
      <p class="titulo-sms-canje">Recibimos tu solicitud</p>
      <p style="font-size:22px">Te brindaremos una respuesta al Whatsapp <b>{{devolverPerfil.sCelular}}</b> en un plazo máximo de 24 horas, dentro de nuestro  horario de atención.</p>
    
            </div>
</ModalPeque>
<ModalPeque v-show="ModalPeque.isMensajeValidacionCo" :peque="ModalPeque">
    <div class="col-md-12" >
      <p class="titulo-sms-canje">Recibimos tu solicitud</p>
      
      <p style="font-size:22px">Te brindaremos una respuesta al correo <b>{{devolverPerfil.sCorreoPromotora}}</b> en un plazo máximo de 24 horas, dentro de nuestro  horario de atención.</p>
            </div>
</ModalPeque>
  <div class="overlay-wrapper" v-if="load">
    <div class="overlay" style="flex-direction: column">
      <i class="fas fa-3x fa-sync-alt fa-spin"></i>
      <div class="text-bold pt-2">Cargando...</div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["content"],
  data: function () {
    return {
      Nombres:"",
      Apellidos:"",
      DNI : "",
      devolverPerfil :[],
      modalload:false,
      mensajebotonmodal :false,
      validacion:true,
      modificar:false,
      inputdisabled:false,
      smsTime : 0,
      smsInterval : null,
      sendSms : false,
      smsPendAproved: true,
      ConformeCel : false,
      codeSms : null,
      codeInserted: "",
      celularValidar: null,
      celularValidado: null,
      name:"",
      smsTimecorreo : 0,
      smsIntervalcorreo : null,
      sendSmscorreo : false,
      smsPendAprovedcorreo: true,
      ConformeCorreo : false,
      codeSmscorreo : null,
      codeInsertedcorreo: "",
      correoValidar: null,
      correoValidado: null,
      ModalValidaCel:false,
      PERFIL_WHATSAPP :localStorage.PERFIL_WHATSAPP,
      PERFIL_CORREO :localStorage.PERFIL_CORREO,
      MotivoCorreo:"",
      correo:"",
      celular:"",
      FotoPortada : true,
      CargadoPortada:false,
      ModalValidaCorreo:false,
      NombrePortada:"", 
      MotivoCel:"",
      load:false,
      devolverPerfil : [],
      Perfil: {
        direccion : "",
        celular : "",
        correo: "",
      },
      ModalPeque: {
        titulo : "",
        mensaje:false,
        isValidaCel:false,
        isValidaCorreo:false,
        isMensajeCanje:false,
        isMensajeFalta:false,
        isMensajeValidacionCel:false,
        isMensajeValidacionCo:false,
        cerrar:""
    
      },
    };
  },
  computed:{
    timeLeft(){
      let timeLeft = this.smsTime / 60;
      let minutes = parseInt(timeLeft);
			let seconds = Math.round((timeLeft - minutes) * 60);
      if (seconds < 10) {
        seconds = `0${seconds}`;
      }
      return minutes+":"+seconds;
    },
    timeLeftcorreo(){
      let timeLeftcorreo = this.smsTimecorreo / 60;
      let minutes = parseInt(timeLeftcorreo);
			let seconds = Math.round((timeLeftcorreo - minutes) * 60);
      if (seconds < 10) {
        seconds = `0${seconds}`;
      }
      return minutes+":"+seconds;
    }
  },
  watch: {
    Celular(newValue){
      if (this.celularValidado && newValue == this.celularValidado) {
        this.smsPendAproved = false;
        this.sendSms = false;
      }
      else{
        this.smsPendAproved = true;
        if (this.celularValidar == newValue) {
          this.sendSms = true;  
        }else{
          this.sendSms = false;  
        }
      }
      return newValue;
    },
    Correo(newValueCorreo){
      if (this.correoValidado && newValueCorreo == this.correoValidado) {
        this.smsPendAprovedcorreo = false;
        this.sendSmscorreo = false;
      }
      else{
        this.smsPendAprovedcorreo = true;
        if (this.correoValidar == newValueCorreo) {
          this.sendSmscorreo = true;  
        }else{
          this.sendSmscorreo = false;  
        }
      }
    return newValueCorreo;
    },
    timeLeft(){
      if (this.smsTime == 0) {
        this.smsTimeUp();
      }
    },
    timeLeftcorreo(){
      if (this.smsTimecorreo == 0) {
        this.smsTimeUpCorreo();
      }
    }
  },
  mounted() {
    this.content.title = "ACTUALIZAR PERFIL";
    this.content.showBody = true;
    this.Celular = this.content.devolverPerfil.sCelular;
    this.Email = this.content.devolverPerfil.sCorreoPromotora;
    this.dtFechaConfirmacionCelular = this.content.devolverPerfil.dtFechaConfirmacionCelular;
    let backend = this.$store.state.backend;
    this.axios.get(backend + "/api/devolverPerfil", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then((response) => {
          this.load=false;
          this.devolverPerfil = response.data.o;
          this.name =  this.devolverPerfil.sNombre_2
          this.DNI = this.devolverPerfil.sDni;
         
           this.content.devolverPerfil = response.data.o;
           this.content.tipoPromotor = this.content.devolverPerfil.sCodClienteSAP.substr(0,2); 
           this.content.ValidacionDNI = this.content.devolverPerfil.nDNIConfirmado;
           this.content.ValidacionCorreo = this.content.devolverPerfil.nCorreoConfirmado;
           this.content.ValidacionCelular = this.content.devolverPerfil.nCelularConfirmado;
          if(this.content.ValidacionDNI == 1 &&  this.content.ValidacionCelular == 1 ){
         /*let ipbackend = this.$store.state.backend;
            this.axios
            .get(ipbackend+'/api/Premios/ConsultaPremios',{
                  headers:{
                      Authorization: "Bearer " + localStorage.token,      
                  },
            })
            .then((response)=>{
            const validacion = response.data.obeStatusCliente.nCompraCampanaActual;
            if(validacion == 1){
            this.ModalPeque.isMensajeCanje=true;
            this.ModalPeque.titulo = "PREMIO";
            }
           
           })*/

          }

        })
  },
  methods: {
    ModalCel(){
    this.ModalPeque.isValidaCel = true;
    this.ModalPeque.titulo="Soporte de Verificación de Datos";
    this.ModalPeque.mensaje=false;
    this.FotoPortada =false;
    this.NombrePortada ="";
    this.FilePortada="";
    this.CargadoPortada=false;
    this.MotivoCel = "";
    },
    GuardarCel(){
    if(this.devolverPerfil.sCelular == "" || this.MotivoCel == "" || this.FilePortada == ""){
    Swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              }).fire({
                icon: "error",
                title: "Debe llenar todo los campo y adjuntar el screenshot.",
              });
    return;
    }
    let ipbackendoms = this.$store.state.backend;
    var data = "";
    data =
               "0|"+this.devolverPerfil.sCelular+
                "|1|" +
                this.MotivoCel +
                "|0|";
        var bodyFormData = new FormData();
        bodyFormData.append("adjuntoFormulario", this.FilePortada);
        bodyFormData.append("sData", data);
        this.axios
          .post(
            ipbackendoms + "/api/Promotor/ValidacionFormulario",
            bodyFormData,
            {
              headers: {
                Authorization: "Bearer " + localStorage.token,
                "Content-Type": "multipart/form-data",
              },
            }
          )
          .then((response) => {
            const data_res = response.data.oResult.bSatisfactorio;
            const mensaje = response.data.oResult.sMessage;

            if (data_res == true) {
              this.ModalValidaCel = false;
              this.ModalPeque.isValidaCel = false;
              this.ModalPeque.isMensajeValidacionCel = true;
              this.ModalPeque.titulo= "Mensaje de Confirmación";
              this.ModalPeque.cerrar = 0;
              

            } else {
              Swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              }).fire({
                icon: "error",
                title: mensaje,
              });
              return;
            }
          })
         
    
    },
    ModalCorreo(){
    this.ModalPeque.isValidaCorreo = true;
    this.ModalPeque.titulo="Soporte de Verificación de Datos";
    this.ModalPeque.mensaje=false;
    this.FotoPortada =false;
    this.NombrePortada ="";
    this.FilePortada="";
    this.CargadoPortada=false;
    this.MotivoCorreo = "";
    },
    GuardarCorreo(){
    var correo = this.devolverPerfil.sCorreoPromotora;
  
    if(this.devolverPerfil.sCorreoPromotora == "" || this.MotivoCorreo == "" || this.FilePortada == ""){
    Swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              }).fire({
                icon: "error",
                title: "Debe llenar todo los campo y adjuntar el screenshot.",
              });
    return;
    }
    let ipbackendoms = this.$store.state.backend;
    var data = "";
    data =
                "0|"+correo +
                "|2|" +
                this.MotivoCorreo +
                "|0|";
        var bodyFormData = new FormData();
        bodyFormData.append("adjuntoFormulario", this.FilePortada);
        bodyFormData.append("sData", data);
        this.axios
          .post(
            ipbackendoms + "/api/Promotor/ValidacionFormulario",
            bodyFormData,
            {
              headers: {
                Authorization: "Bearer " + localStorage.token,
                "Content-Type": "multipart/form-data",
              },
            }
          )
          .then((response) => {
            const data_res = response.data.oResult.bSatisfactorio;
            const mensaje = response.data.oResult.sMessage;
          
            if (data_res == true) {
              this.ModalValidaCorreo = false;
              this.ModalPeque.isValidaCorreo = false;
              this.ModalPeque.isMensajeValidacionCo = true;
              this.ModalPeque.titulo= "Mensaje de Confirmación";
              this.ModalPeque.cerrar=0;
              

            } else {
              Swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              }).fire({
                icon: "error",
                title: mensaje,
              });
              return;
            }
          })
         
    
    },
    CargaIMG(){
    this.FotoPortada =false;
    const file = document.getElementById('portada').files[0];
    let reader = new FileReader();

    // Leemos el archivo subido y se lo pasamos a nuestro fileReader
    reader.readAsDataURL(file);

    // Le decimos que cuando este listo ejecute el código interno
    reader.onload = function(){
          let preview = document.getElementById('preview'),
          image = document.createElement('img');
          image.style.width = "100%";
          image.style.padding="15px 0px";
          image.src = reader.result;
          preview.innerHTML = '';
          preview.append(image);
    }
        
        this.FilePortada = file;
        this.NombrePortada = document.getElementById('portada').files[0].name;
    
        if(this.NombrePortada != ""){
        this.CargadoPortada=true;
        Swal.mixin({
              toast: true,
              position: 'top-end',
              showConfirmButton: false,
              timer: 3000
            }).fire({
            icon: "success",
            title:  "Se cargó el documento "+this.NombrePortada,
            }); 
        }

    },
    CargaIMGCorreo(){
    this.FotoPortada =false;
    const file = document.getElementById('fotocorreo').files[0];
    let reader = new FileReader();

    // Leemos el archivo subido y se lo pasamos a nuestro fileReader
    reader.readAsDataURL(file);

    // Le decimos que cuando este listo ejecute el código interno
    reader.onload = function(){
          let preview = document.getElementById('previewcorreo'),
          image = document.createElement('img');
          image.style.width = "100%";
          image.style.padding="15px 0px";
          image.src = reader.result;
          preview.innerHTML = '';
          preview.append(image);
    }
        
        this.FilePortada = file;
        this.NombrePortada = document.getElementById('fotocorreo').files[0].name;
      
        if(this.NombrePortada != ""){
        this.CargadoPortada=true;
        Swal.mixin({
              toast: true,
              position: 'top-end',
              showConfirmButton: false,
              timer: 3000
            }).fire({
            icon: "success",
            title:  "Se cargó el documento "+this.NombrePortada,
            }); 
        }

    },
    Limpiar(){
    this.DNI="";
    this.Nombres="";
    this.Apellidos="";
    },
    LimpiarCel(){
    this.sendSms=false;
    this.codeInserted = "";
    this.content.ValidacionCelular = "";
    },
    LimpiarCorreo(){
    this.sendSmscorreo=false;
    this.codeInsertedcorreo = "";
    this.content.ValidacionCorreo = "";
    },
     ModiDNI(){
      if(this.devolverPerfil.sDni.length != 8 || this.Apellidos == "" || this.Nombres == ""){
      const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        });
        Toast.fire({
        icon: "error",
        title: "Debe llenar todos los campos correctamente",
        });
      }
      else{
      var dni = this.devolverPerfil.sDni;
      var apellidos = this.Apellidos;
      var nombres = this.Nombres;
      var dataprocess = "";
      dataprocess +=
             dni +"|" +nombres + "|"+
              apellidos +
              "||";

  
    let ipbackend = this.$store.state.backend;
    var bodyFormData = new FormData();
    bodyFormData.append("sData", dataprocess);
    this.modalload = true;
      this.axios
        .post(ipbackend + "/api/Promotor/ConfirmacionDatosPromotor", bodyFormData, {
          headers: {
            Authorization: "Bearer " + localStorage.token,
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          this.modalload = false;

          const data_res = response.data.oResult;
           const mensaje = response.data.obePromotoraConfirmacion;
          if (data_res.bSatisfactorio) {

           const Toast = Swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            });
            Toast.fire({
              icon: "success",
              title: mensaje.sDescRespuesta,
            });
              this.axios
        .get(ipbackend + "/api/devolverPerfil", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then((response) => {
           this.content.devolverPerfil = response.data.o;
           this.content.tipoPromotor = this.content.devolverPerfil.sCodClienteSAP.substr(0,2); 
           this.content.ValidacionDNI = this.content.devolverPerfil.nDNIConfirmado;
           this.content.ValidacionCorreo = this.content.devolverPerfil.nCorreoConfirmado;
           this.content.ValidacionCelular = this.content.devolverPerfil.nCelularConfirmado;
          if(this.content.ValidacionDNI == 1 &&  this.content.ValidacionCelular == 1 ){
         let ipbackend = this.$store.state.backend;
            this.axios
            .get(ipbackend+'/api/Premios/ConsultaPremios',{
                  headers:{
                      Authorization: "Bearer " + localStorage.token,      
                  },
            })
            .then((response)=>{
            const validacion = response.data.obeStatusCliente.nCompraCampanaActual;
            if(validacion != 1){
            this.ModalPeque.isMensajeFalta=true;
            this.ModalPeque.titulo = "PREMIO";
            }
            else{
            this.ModalPeque.isMensajeCanje=true;
            this.ModalPeque.titulo = "PREMIO";
            }
            })
            }
            else if (this.content.ValidacionDNI == 0 &&  this.content.ValidacionCelular == 1 ||
            this.content.ValidacionDNI == 1 && this.content.ValidacionCelular == 0 
            ){
          
             const Toast = Swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            });
            Toast.fire({
              icon: "success",
              title: mensaje.sDescRespuesta,
            });
            }
            else  {
            
            }

          if(this.content.ValidacionDNI == 1 && this.content.ValidacionCorreo == 1 && this.content.ValidacionCelular == 1){
            this.visible = false;
          }
          else if (this.content.ValidacionDNI == 0 && this.content.ValidacionCorreo == 1 && this.content.ValidacionCelular == 1 ||
            this.content.ValidacionDNI == 1 && this.content.ValidacionCorreo == 0 && this.content.ValidacionCelular == 1 ||
            this.content.ValidacionDNI == 1 && this.content.ValidacionCorreo == 1 && this.content.ValidacionCelular == 0
          ){
          this.content.contador = 1
          }
          else if (this.content.ValidacionDNI == 0 && this.content.ValidacionCorreo == 0 && this.content.ValidacionCelular == 1 ||
            this.content.ValidacionDNI == 1 && this.content.ValidacionCorreo == 0 && this.content.ValidacionCelular == 0 ||
            this.content.ValidacionDNI == 0 && this.content.ValidacionCorreo == 1 && this.content.ValidacionCelular == 0
          ){
          this.content.contador = 2
          }
          else {
          this.content.contador = 3
          }
          
        })
          } else {
            const Toast = Swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 6000,
            });
            Toast.fire({
              icon: "error",
              title: mensaje.sDescRespuesta,
            });
          }
        })
     }
    },
    ValidacionDNI(){
      var dni = this.devolverPerfil.sDni;
      var apellidos = this.devolverPerfil.sNombre_1;
      var nombres = this.devolverPerfil.sNombre_2;
      var dataprocess = "";
      dataprocess +=
             dni +"|" +nombres + "|"+
              apellidos +
              "||";


    let ipbackend = this.$store.state.backend;
    var bodyFormData = new FormData();
    bodyFormData.append("sData", dataprocess);
    this.modalload = true;
      this.axios
        .post(ipbackend + "/api/Promotor/ConfirmacionDatosPromotor", bodyFormData, {
          headers: {
            Authorization: "Bearer " + localStorage.token,
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          this.modalload = false;
          const data_res = response.data.oResult;
           const mensaje = response.data.obePromotoraConfirmacion;
          if (data_res.bSatisfactorio) {
          
            this.axios
        .get(ipbackend + "/api/devolverPerfil", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then((response) => {
          this.content.devolverPerfil = response.data.o;
           this.content.tipoPromotor = this.content.devolverPerfil.sCodClienteSAP.substr(0,2); 
           this.content.ValidacionDNI = this.content.devolverPerfil.nDNIConfirmado;
           this.content.ValidacionCorreo = this.content.devolverPerfil.nCorreoConfirmado;
           this.content.ValidacionCelular = this.content.devolverPerfil.nCelularConfirmado;
          if(this.content.ValidacionDNI == 1 &&  this.content.ValidacionCelular == 1){
         let ipbackend = this.$store.state.backend;
            this.axios
            .get(ipbackend+'/api/Premios/ConsultaPremios',{
                  headers:{
                      Authorization: "Bearer " + localStorage.token,      
                  },
            })
            .then((response)=>{
            const validacion = response.data.obeStatusCliente.nCompraCampanaActual;
            if(validacion != 1){
            this.ModalPeque.isMensajeFalta=true;
            this.ModalPeque.titulo = "PREMIO";
            }
            else{
            this.ModalPeque.isMensajeCanje=true;
            this.ModalPeque.titulo = "PREMIO";
            }
            })
            }
            else if (this.content.ValidacionDNI == 0 &&  this.content.ValidacionCelular == 1 ||
            this.content.ValidacionDNI == 1 && this.content.ValidacionCelular == 0 
            ){
          
             const Toast = Swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            });
            Toast.fire({
              icon: "success",
              title: mensaje.sDescRespuesta,
            });
            }
            else  {
            
            }

          if(this.content.ValidacionDNI == 1 && this.content.ValidacionCorreo == 1 && this.content.ValidacionCelular == 1){
            this.visible = false;
          }
          else if (this.content.ValidacionDNI == 0 && this.content.ValidacionCorreo == 1 && this.content.ValidacionCelular == 1 ||
            this.content.ValidacionDNI == 1 && this.content.ValidacionCorreo == 0 && this.content.ValidacionCelular == 1 ||
            this.content.ValidacionDNI == 1 && this.content.ValidacionCorreo == 1 && this.content.ValidacionCelular == 0
          ){
          this.content.contador = 1
          }
          else if (this.content.ValidacionDNI == 0 && this.content.ValidacionCorreo == 0 && this.content.ValidacionCelular == 1 ||
            this.content.ValidacionDNI == 1 && this.content.ValidacionCorreo == 0 && this.content.ValidacionCelular == 0 ||
            this.content.ValidacionDNI == 0 && this.content.ValidacionCorreo == 1 && this.content.ValidacionCelular == 0
          ){
          this.content.contador = 2
          }
          else {
          this.content.contador = 3
          }
          })
        }
        })
    },
    smsValidateCorreo(){
      const codeSmscorreo = this.codeSmscorreo;
      const codeInsertedcorreo = this.codeInsertedcorreo;

      if (!codeInsertedcorreo) {
        const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000
        });
        Toast.fire({
        icon: 'error',
        title: 'Digite el Codigo del correo'
        })
        return;
      }
      if (codeSmscorreo == codeInsertedcorreo && this.Correo == this.correoValidar) {
        this.smsPendAprovedcorreo = false;
        this.correoValidado = this.Correo;
        this.correoValidar = null;
        var correo = this.devolverPerfil.sCorreoPromotora;
        var dataprocess = "";
        dataprocess +=
             "||||" +correo;

   
        let ipbackend = this.$store.state.backend;
        var bodyFormData = new FormData();
        bodyFormData.append("sData", dataprocess);
        this.modalload = true;
          this.axios
            .post(ipbackend + "/api/Promotor/ConfirmacionDatosPromotor", bodyFormData, {
              headers: {
                Authorization: "Bearer " + localStorage.token,
                "Content-Type": "multipart/form-data",
              },
            })
          .then((response) => {
          this.modalload = false;
          const data_res = response.data.oResult;
          const mensaje = response.data.obePromotoraConfirmacion;
          if (data_res.bSatisfactorio) {
          const Toast = Swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            });
            Toast.fire({
              icon: "success",
              title: mensaje.sDescRespuesta,
            });
          this.axios
          .get(ipbackend + "/api/devolverPerfil", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
          })
          .then((response) => {
          this.content.devolverPerfil = response.data.o;
          this.content.tipoPromotor = this.content.devolverPerfil.sCodClienteSAP.substr(0,2); 
          this.content.ValidacionDNI = this.content.devolverPerfil.nDNIConfirmado;
          this.content.ValidacionCorreo = this.content.devolverPerfil.nCorreoConfirmado;
          this.content.ValidacionCelular = this.content.devolverPerfil.nCelularConfirmado;
          if(this.content.ValidacionDNI == 1 && this.content.ValidacionCorreo == 1 && this.content.ValidacionCelular == 1){
            this.visible = false;
          }
          else if (this.content.ValidacionDNI == 0 && this.content.ValidacionCorreo == 1 && this.content.ValidacionCelular == 1 ||
            this.content.ValidacionDNI == 1 && this.content.ValidacionCorreo == 0 && this.content.ValidacionCelular == 1 ||
            this.content.ValidacionDNI == 1 && this.content.ValidacionCorreo == 1 && this.content.ValidacionCelular == 0
          ){
          this.content.contador = 1
          }
          else if (this.content.ValidacionDNI == 0 && this.content.ValidacionCorreo == 0 && this.content.ValidacionCelular == 1 ||
            this.content.ValidacionDNI == 1 && this.content.ValidacionCorreo == 0 && this.content.ValidacionCelular == 0 ||
            this.content.ValidacionDNI == 0 && this.content.ValidacionCorreo == 1 && this.content.ValidacionCelular == 0
          ){
          this.content.contador = 2
          }
          else {
          this.content.contador = 3
          }
        })
        } else {
            const Toast = Swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            });
            Toast.fire({
              icon: "error",
              title: mensaje.sDescRespuesta,
            });
          }
        })
        document.getElementById('email').disabled = true;
        }else{
        const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000
        });
        Toast.fire({
        icon: 'error',
        title: 'Codigo no valido'
        })
        return;
        }
      },
     smsValidate(){
      const codeSms = this.codeSms;
      const codeInserted = this.codeInserted;
      if (!codeInserted) {
        const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000
        });
        Toast.fire({
        icon: 'error',
        title: 'Digite el Codigo del SMS'
        })
        return;
      }
      if (codeSms == codeInserted && this.Celular == this.celularValidar) {
        this.smsPendAproved = false;
        this.celularValidado = this.Celular;
        this.celularValidar = null;
        var cel = this.devolverPerfil.sCelular;
        var dataprocess = "";
        dataprocess +=
             "|||" +cel+ 
              "|";
        let ipbackend = this.$store.state.backend;
        var bodyFormData = new FormData();
        bodyFormData.append("sData", dataprocess);
        this.modalload = true;
        this.axios
          .post(ipbackend + "/api/Promotor/ConfirmacionDatosPromotor", bodyFormData, {
            headers: {
            Authorization: "Bearer " + localStorage.token,
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
        this.modalload = false;
        const data_res = response.data.oResult;
        const mensaje = response.data.obePromotoraConfirmacion;
        if (data_res.bSatisfactorio) {
        const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        });
        Toast.fire({
        icon: "success",
        title: mensaje.sDescRespuesta,
        });
        this.axios
        .get(ipbackend + "/api/devolverPerfil", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then((response) => {
        this.content.devolverPerfil = response.data.o;
        this.content.tipoPromotor = this.content.devolverPerfil.sCodClienteSAP.substr(0,2);
        this.content.ValidacionDNI = this.content.devolverPerfil.nDNIConfirmado;
        this.content.ValidacionCorreo = this.content.devolverPerfil.nCorreoConfirmado;
        this.content.ValidacionCelular = this.content.devolverPerfil.nCelularConfirmado;

         if(this.content.ValidacionDNI == 1 &&  this.content.ValidacionCelular == 1 ){
         let ipbackend = this.$store.state.backend;
            this.axios
            .get(ipbackend+'/api/Premios/ConsultaPremios',{
                  headers:{
                      Authorization: "Bearer " + localStorage.token,
                  },
            })
            .then((response)=>{
            const validacion = response.data.obeStatusCliente.nCompraCampanaActual;
      
            if(validacion != 1){
            this.ModalPeque.isMensajeFalta=true;
            this.ModalPeque.titulo = "PREMIO";
            }
            else{
            this.ModalPeque.isMensajeCanje=true;
            this.ModalPeque.titulo = "PREMIO";
            }
            })
            }
            else if (this.content.ValidacionDNI == 0 &&  this.content.ValidacionCelular == 1 ||
            this.content.ValidacionDNI == 1 && this.content.ValidacionCelular == 0 
            ){
          
             const Toast = Swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            });
            Toast.fire({
              icon: "success",
              title: mensaje.sDescRespuesta,
            });
            }
            else  {
            
            }

          if(this.content.ValidacionDNI == 1 && this.content.ValidacionCorreo == 1 && this.content.ValidacionCelular == 1){
            this.visible = false;
          }
          else if (this.content.ValidacionDNI == 0 && this.content.ValidacionCorreo == 1 && this.content.ValidacionCelular == 1 ||
            this.content.ValidacionDNI == 1 && this.content.ValidacionCorreo == 0 && this.content.ValidacionCelular == 1 ||
            this.content.ValidacionDNI == 1 && this.content.ValidacionCorreo == 1 && this.content.ValidacionCelular == 0
          ){
          this.content.contador = 1
          }
          else if (this.content.ValidacionDNI == 0 && this.content.ValidacionCorreo == 0 && this.content.ValidacionCelular == 1 ||
            this.content.ValidacionDNI == 1 && this.content.ValidacionCorreo == 0 && this.content.ValidacionCelular == 0 ||
            this.content.ValidacionDNI == 0 && this.content.ValidacionCorreo == 1 && this.content.ValidacionCelular == 0
          ){
          this.content.contador = 2
          }
          else {
          this.content.contador = 3
          }



        })
        } else {
        const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        });
        Toast.fire({
              icon: "error",
              title: mensaje.sDescRespuesta,
            });
          }
        })

      document.getElementById('celu').disabled = true;
      }else{
        const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000
        });
        Toast.fire({
        icon: 'error',
        title: 'Codigo no valido'
        })
        return;
      }
      
    },
    smsTimeUp(){
      this.codeSms = null;
      this.celularValidar = null;
      clearInterval(this.smsInterval);
    },
    smsTimeUpCorreo(){
      this.codeSmscorreo = null;
      this.correoValidar = null;
      clearInterval(this.smsIntervalcorreo);
    },
    smsTimeStart(){
      this.smsTime = 420;
      this.smsInterval = setInterval(() => (this.smsTime -= 1), 1000);
      this.sendSms = true;
    },
    smsTimeStartcorreo(){
      this.smsTimecorreo = 420;
      this.smsIntervalcorreo = setInterval(() => (this.smsTimecorreo -= 1), 1000);
      this.sendSmscorreo = true;
    },
    reSendSms(evt){
      evt.preventDefault();
      this.celularVerify();
    },
    reSendSmsCorreo(evt){
      evt.preventDefault();
      this.correoVerify();
    },
    correoVerify(){
    this.Correo = this.devolverPerfil.sCorreoPromotora;
    this.codeInsertedcorreo = "";
    this.modalload = true;
      const ipbackend = this.$store.state.backend;
      var bodyFormData = new FormData();
      bodyFormData.append("sData", this.Correo);
      this.axios.post(ipbackend+"/api/Promotor/ValidacionTokenCorreo",bodyFormData, {
      headers: {
      Authorization: "Bearer " + localStorage.token,
      "Content-Type": "multipart/form-data",
          },
        }).then((response) => {
          const dataRes = response.data;
          this.modalload = false;
          this.ModalValidaCorreo = false;
          if(dataRes.oResult.bSatisfactorio){  
            this.smsTimeStartcorreo();
            this.correoValidar = this.Correo;
            /*this.codeSmscorreo = dataRes.codigo;*/
            var rpta = "";
            var n = dataRes.codigo.length;
            for (var i = 0; i < n; i++) {
                rpta += String.fromCharCode(dataRes.codigo.charCodeAt(i) ^ 10);
            }
          this.codeSmscorreo = rpta;
          console.log(this.codeSmscorreo)
          }else{
 
            if(dataRes.oResult.sMessage.substring(0,5) == "Usted"){
            const Toast = Swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 10000
            });
            Toast.fire({
            icon: 'error',
            title: dataRes.oResult.sMessage,
            });
            this.ModalValidaCorreo = true;
            this.sendSmscorreo=false;
            }
            else{
            this.ModalValidaCorreo = false;
            this.sendSmscorreo=false;
            const Toast = Swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 10000
            });
            Toast.fire({
            icon: 'error',
            title: dataRes.oResult.sMessage,
            });
            }
            
          }
        });
    },
    celularVerify(){
    this.Celular = this.devolverPerfil.sCelular;
    this.codeInserted = "";
       if (this.Celular > 999999999) {
        const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000
        });
        Toast.fire({
        icon: 'error',
        title: 'El Celular debe contar con 9 dígitos'
        })
        return;
      }
      this.modalload = true;
      const ipbackend = this.$store.state.backend;
      var bodyFormData = new FormData();
      bodyFormData.append("sData", this.Celular);
      this.axios.post(ipbackend+"/api/Promotor/ValidacionTokenSms",bodyFormData, {
      headers: {
      Authorization: "Bearer " + localStorage.token,
      "Content-Type": "multipart/form-data",
          },
        }).then((response) => {
          const dataRes = response.data;
          this.modalload =  false;
          this.ModalValidaCel = false;
          if(dataRes.oResult.bSatisfactorio){
            this.smsTimeStart();
            this.celularValidar = this.Celular;

            var rpta = "";
            var n = dataRes.codigo.length;
            for (var i = 0; i < n; i++) {
                rpta += String.fromCharCode(dataRes.codigo.charCodeAt(i) ^ 10);
            }
            this.codeSms = rpta;
            console.log(this.codeSms)
          }else{

            if(dataRes.oResult.sMessage.substring(0,5) == "Usted"){
            const Toast = Swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 10000
            });
            Toast.fire({
            icon: 'error',
            title: dataRes.oResult.sMessage,
            });
            this.ModalValidaCel = true;
            this.sendSms=false;
            }
            else{
            this.ModalValidaCel = false;
            this.sendSms=false;
            const Toast = Swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 10000
            });
            Toast.fire({
            icon: 'error',
            title: dataRes.oResult.sMessage,
            });
            }
            
          }
        });
    },
    MaxNumberCell : function (evt) {   
    evt = (evt) ? evt : window.event;
    const value = evt.target.value;
    var charCode = (evt.which) ? evt.which : evt.keyCode;
    if ( value.length < 9 && (charCode >= 48 && charCode <= 57)  ) {
    return true;
    }
    else{
    $(function() {
    const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000
    });
    Toast.fire({
    icon: 'error',
    title: 'Su celular debe contar 9 dígitos como máximo'
    })
    });
    evt.preventDefault();
    } 
    },
    maxCode(evt){
      evt = (evt) ? evt : window.event;
      const value = evt.target.value;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ( value.length < 5 && (charCode >= 48 && charCode <= 57)  ) {
      return true;
      }else{
      $(function() {
      const Toast = Swal.mixin({
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 3000
      });
      Toast.fire({
      icon: 'error',
      title: 'El codigo debe contar con 5 dígitos como máximo'
      })
      });
      evt.preventDefault();
    }
    },
    NoConforme(){
    this.validacion=false;
    this.modificar=true;
    this.Nombres = "";
    this.Apellidos = "";
    var dni = this.DNI;
    this.inputdisabled = true
    },
    Retorno(){
    this.validacion=true;
    this.mensajebotonmodal = false;
    this.modificar=false;
    this.Nombres = "";
    this.Apellidos = "";
    },
    Reniec(){
    this.modalload=true;
    var dni = this.DNI;
    const ipbackend = this.$store.state.backendoms;
    if(dni.length != 8){
             Swal.mixin({
              toast: true,
              position: 'top-end',
              showConfirmButton: false,
              timer: 3000
            }).fire({
              icon: 'error',
              title: 'Su DNI debe contar con 8 dígitos',
            });  
      this.modalload=false;
    }
    else{
    this.axios.get(ipbackend +'/api/Empresaria/BuscarReniec?sDni='+dni,{headers: {
          'Authorization' : 'Bearer ' + localStorage.token
          }}).then((response) => {
            const data_res = response.data;
            const Reniec = response.data.sMessage;
            this.modalload=false;
          if (data_res.bSatisfactorio === true) {
             var nombrecompleto = Reniec.split("|");
             this.Nombres = nombrecompleto[1];
             this.Apellidos = nombrecompleto[0];
         
          }
          else{
            this.Nombres = "";
            this.Apellidos = "";
            
             Swal.mixin({
              toast: true,
              position: 'top-end',
              showConfirmButton: false,
              timer: 3000
            }).fire({
              icon: 'error',
              title: Reniec,
            });  
            return;
          }
      });
    }
    },
    MaxNumber : function (evt) {
          evt = (evt) ? evt : window.event;
          const value = evt.target.value;
          var charCode = (evt.which) ? evt.which : evt.keyCode;
          
           if ( value.length < 8 && (charCode >= 48 && charCode <= 57) ) {
            return true;
          }else{
          $(function() {
          const Toast = Swal.mixin({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
          });
          Toast.fire({
          icon: 'error',
          title: 'Su DNI debe contar con 8 dígitos'
          })

          });
            evt.preventDefault();
          }
    
    },
  
  },
};
</script>
<style scoped>
#preview img{
width:100%  
}
.custom-file-label::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 3;
    display: block;
    height: 2.30rem;
    padding: 0.375rem 0.75rem;
    line-height: 1.5;
    color: #ffffff;
    background-color: rgb(90, 45, 130) !important;
    border-color: rgb(90, 45, 130) !important;
    content: "Adjuntar" !important;
    border-left: inherit;
    border-radius: 0 0.25rem 0.25rem 0;
}
</style>